import { FamilyStep } from "@domain/product/monitoring/family/family-step";
import { FamilyDto } from "@lib/dtos/monitoring/family/family.dto";
import { Type } from "class-transformer";

export class Family extends FamilyDto {
  @Type(() => FamilyStep)
  override steps!: FamilyStep[];

  constructor(
    familyName: string,
    familyNumber: string,
    steps: FamilyStep[],
    countries: string[],
    familyImageCantoId?: string,
    familyDescription?: string,
    familyPiSheetUrl?: string,
  ) {
    super();
    this.familyName = familyName;
    this.familyNumber = familyNumber;
    this.steps = steps;
    this.countries = countries;
    this.familyImageCantoId = familyImageCantoId;
    this.familyDescription = familyDescription;
    this.familyPiSheetUrl = familyPiSheetUrl;
  }
}
